// frontend/src/components/common/CollectionTileWithBulkOnline.jsx
// Wrapper component that adds online availability to CollectionTile using bulk data

import React from 'react';
import CollectionTile from '../features/CollectionTile';

const CollectionTileWithBulkOnline = ({ game, getGameAvailability, ...collectionTileProps }) => {
  // Get availability from bulk results if function is provided
  const gameId = game.game_id || game.id;
  let onlineVenues = [];

  if (getGameAvailability && typeof getGameAvailability === 'function') {
    const availabilityData = getGameAvailability(gameId);
    onlineVenues = availabilityData?.venues || [];
  }

  return (
    <CollectionTile
      game={game}
      onlineVenues={onlineVenues}
      {...collectionTileProps}
    />
  );
};

export default CollectionTileWithBulkOnline;
